'use client'

import textBodySStrong from '@fukku/styles/texts/textBodySStrong.module.css'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { cx } from 'utils/cx'

import styles from '../ExtraInfo.module.css'

export type TitlePops = {
	readonly title: string
}
export const Title = ({ title }: TitlePops) => {
	const { t } = useLabels()
	return (
		<p className={cx(styles.title, textBodySStrong.className)}>{t(title)}</p>
	)
}
